import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

const initialState = {
  loading: {
    fetchingTiers: false,
    creatingSubscription: false,
    fetchingSubscription: false,
    updatingTier: false,
    updatingPaymentMethod: false,
    cancellingSubscription: false,
    renewingSubscription: false,
    fetchingHistory: false,
    fetchingMessagingCharges: false,
  },
  tiers: [],
  tier: null,
  subscription: null,
  history: [],
  messagingCharges: [],
}

export const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      const alteredState = {
        ...state,
        loading: { ...state.loading, ...payload },
      }
      return alteredState
    },
    setTiers: (state, { payload }) => {
      const alteredState = {
        ...state,
        tiers: payload,
      }
      return alteredState
    },
    setTier: (state, { payload }) => {
      const alteredState = {
        ...state,
        tier: payload,
      }
      return alteredState
    },
    setSubscription: (state, { payload }) => {
      const alteredState = {
        ...state,
        subscription: payload,
      }
      return alteredState
    },
    setHistory: (state, { payload }) => {
      const alteredState = {
        ...state,
        history: payload,
      }
      return alteredState
    },
    setMessagingCharges: (state, { payload }) => {
      const alteredState = {
        ...state,
        messagingCharges: payload,
      }
      return alteredState
    },
    reset: () => initialState,
  },
})

export const useBillingSelector = () => useSelector((state) => state.billing)
export const billingActions = billingSlice.actions
export const billingReducer = billingSlice.reducer
